import { FactoryProvider } from '@angular/core';

import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';

import { OPTION_CARDS_TRANSLATIONS, OptionCardsTranslations } from '@hdms/shared/ui-core';

export const OPTION_CARDS_TRANSLATIONS_PROVIDER: FactoryProvider = {
  provide: OPTION_CARDS_TRANSLATIONS,
  deps: [I18NEXT_SERVICE],
  useFactory: (i18NextService: ITranslationService): OptionCardsTranslations => ({
    currentOptionDescriptionHidden: i18NextService.t('common.label.form.currentOptionDescriptionHidden'),
    showMoreOptions: i18NextService.t('common.label.form.showMoreOptions')
  })
};
